export default {
	state: {
		breads: [
			{
				id: '000',
				picSrc: '/img/bread/000.jpg',
				bigPic: '/img/bread/000big.jpg',
				name: 'Хлеб Домашний',
				sort: 'РЖАНО-ПШЕНИЧНЫЙ',
				srok: '7 суток',
				descr: 'Ржано-пшеничный мелкопористый хлеб с развитым мякишем на заквашенной заварке. Выпекается на каменном поду путём прямой посадки.  Дополнительная ароматика этого хлеба достигается путем длительной ферментации.'
			},
			{
				id: '001',
				picSrc: '/img/bread/001.jpg',
				bigPic: '/img/bread/001big.jpg',
				name: 'Литовский (ржаной с кориандром) ',
				sort: 'РЖАНО-ПШЕНИЧНЫЙ',
				srok: '7 суток',
				descr: 'Ржано-пшеничный мелкопористый бездрожжевой хлеб на заквашенной заварке. Выпекается на каменном поду путём прямой посадки.  Дополнительная ароматика этого хлеба достигается за счёт длительной ферментации. Значительно уменьшает риск возникновения аллергии на глютен.'
			},
			{
				id: '002',
				picSrc: '/img/bread/002.jpg',
				bigPic: '/img/bread/002big.jpg',
				name: 'Праздничный',
				sort: 'РЖАНО-ПШЕНИЧНЫЙ',
				srok: '7 суток',
				descr: 'Этот ржано-пшеничный мелкопористый бездрожжевой фруктово-ореховый хлеб на заквашенной заварке богат естественными витаминами, микроэлементами и природной клетчаткой. Изготовлен вручную, выпекается на каменном поду по рецептам старинных мастеров. Значительно уменьшает риск возникновения аллергии на глютен.'
			},
			{
				id: '003',
				picSrc: '/img/bread/003.jpg',
				bigPic: '/img/bread/003big.jpg',
				name: 'Энергия',
				sort: 'РЖАНО-ПШЕНИЧНЫЙ',
				srok: '7 суток',
				descr: 'Этот ржано-пшеничный мелкопористый бездрожжевой фруктово-ореховый хлеб на заквашенной заварке богат естественными витаминами, микроэлементами и природной клетчаткой. Изготовлен вручную, выпекается на каменном поду по рецептам старинных мастеров. Значительно уменьшает риск возникновения аллергии на глютен.'
			},
			{
				id: '004',
				picSrc: '/img/bread/004.jpg',
				bigPic: '/img/bread/004big.jpg',
				name: 'Рижский (ржаной с тмином)',
				sort: 'РЖАНО-ПШЕНИЧНЫЙ',
				srok: '7 суток',
				descr: 'Ржано-пшеничный мелкопористый бездрожжевой хлеб на заквашенной заварке. Выпекается на каменном поду путём прямой посадки. Дополнительная ароматика этого хлеба достигается за счёт длительной ферментации. Значительно уменьшает риск возникновения аллергии на глютен.'
			},
			{
				id: '005',
				picSrc: '/img/bread/005.jpg',
				bigPic: '/img/bread/005big.jpg',
				name: 'Ржаной заварной',
				sort: 'РЖАНО-ПШЕНИЧНЫЙ',
				srok: '7 суток',
				descr: 'Ржано-пшеничный хлеб на пшеничной закваске и заварке из темного солода. Хлеб с приятным ароматом ржаной заварки, содержащей множество аминокислот, полезных для организма человека. Изготовлен без использования дрожжей. '
			},
			{
				id: '006',
				picSrc: '/img/bread/006.jpg',
				bigPic: '/img/bread/006big.jpg',
				name: '100% ржаной на закваске',
				sort: 'РЖАНОЙ',
				srok: '7 суток',
				descr: 'Чистый ржаной хлеб с мелкой пористостью на ржаной цельнозерновой закваске. Низкокалорийный диетический хлеб с низким гликемическим индексом, обладающий ржаным вкусом с приятной заквасочной кислинкой. В Ростовской области 100% ржаной хлеб выпекаем только мы. Это сложная задача и немногие берутся за ее выполнение. '
			},
			{
				id: '007',
				picSrc: '/img/bread/007.jpg',
				bigPic: '/img/bread/007big.jpg',
				name: 'Здоровое сердце',
				sort: 'пшенично-ржаной',
				srok: '7 суток',
				descr: 'Пшенично-ржаной хлеб на закваске с неравномерной пористостью. Содержит осолодованные овсяные и ржаные хлопья, а также большое количество цельнозерновых хлопьев. Выпекается без использования дрожжей. Полезный хлеб с большим содержанием семян и зерен, обогащен пищевыми волокнами. 	Состав подобран таким образом, чтобы максимально приносить пользу сердцу и сердечно-сосудистой системе. '
			},
			{
				id: '008',
				picSrc: '/img/bread/008.jpg',
				bigPic: '/img/bread/008big.jpg',
				name: 'Зерновой',
				sort: 'Ржано-пшеничный',
				srok: '7 суток',
				descr: 'Ржано-пшеничный хлеб на закваске с плотным зерновым мякишем. Содержит четыре вида цельных зёрен. Помогает снизить холестерин в крови, улучшает обмен веществ, работу сердца, выводит шлаки. Лён и кунжут содержат большое количество полиненасыщенных жирных кислот, способствующих снижению уровня холестерина в крови.'
			},
			{
				id: '009',
				picSrc: '/img/bread/009.jpg',
				bigPic: '/img/bread/009big.jpg',
				name: 'Шотландский',
				sort: 'пшенично-ржаной',
				srok: '7 суток',
				descr: 'Пшенично-ржаной хлеб с развитой неравномерной пористостью на пшеничной закваске. В его составе вы найдете солод темный ржаной ферментированный, много семян, которые являются источником клетчатки и ягоды, добавляющие нашему хлебу витамины.'
			},
			{
				id: '010',
				picSrc: '/img/bread/010.jpg',
				bigPic: '/img/bread/010big.jpg',
				name: 'Мюсли (с овсяными хлопьями)',
				sort: 'пшенично-ржаной',
				srok: '7 суток',
				descr: 'Пшенично-ржаной хлеб с равномерной пористостью на заквашенной пшеничной заварке, без добавления дрожжей. Это хлеб длительной ферментации, содержащий пророщенную рожь (осолодованную), овсяные хлопья, сушёные фрукты – источники витаминов и клетчатки. Сушёный абрикос и чернослив оказывают мягкое стимулирующее действие на  работу желудочно-кишечного тракта. '
			},
			{
				id: '011',
				picSrc: '/img/bread/011.jpg',
				bigPic: '/img/bread/011big.jpg',
				name: 'Мюсли (с семенем подсолнечника)',
				sort: 'пшенично-ржаной',
				srok: '7 суток',
				descr: 'Пшенично-ржаной хлеб с равномерной пористостью на заквашенной пшеничной заварке, без добавления дрожжей. Это хлеб длительной ферментации, содержащий пророщенную рожь (осолодованную), овсяные хлопья, сушёные фрукты – источники витаминов и клетчатки. Сушёный абрикос и чернослив оказывают мягкое стимулирующее действие на работу желудочно-кишечного тракта. Семена подсолнечника содержит большое количество витамина Е, являющегося витамином молодости. Выпекается без добавления дрожжей.'
			},
			{
				id: '012',
				picSrc: '/img/bread/012.jpg',
				bigPic: '/img/bread/012big.jpg',
				name: 'Мюсли (с семенами тыквы)',
				sort: 'пшенично-ржаной',
				srok: '7 суток',
				descr: 'Пшенично-ржаной хлеб с равномерной пористостью на заквашенной пшеничной заварке, без добавления дрожжей. Это хлеб длительной ферментации, содержащий пророщенную рожь (осолодованную), овсяные хлопья, сушёные фрукты – источники витаминов и клетчатки. Сушёный абрикос и чернослив оказывают мягкое стимулирующее действие на работу желудочно-кишечного тракта. В этом хлебе вы найдете семена тыквы, обладающие непревзойденными антипаразитарными свойствами. Выпекается без добавления дрожжей.'
			},
			{
				id: '013',
				picSrc: '/img/bread/013.jpg',
				bigPic: '/img/bread/013big.jpg',
				name: 'Деревенский',
				sort: 'пшеничный',
				srok: '3 суток',
				descr: 'Пшеничный хлеб на живой пшеничной закваске. Ароматный пшеничный хлеб на пшеничной закваске с румяной корочкой выпекается на каменном поду.'
			},
			{
				id: '014',
				picSrc: '/img/bread/014.jpg',
				bigPic: '/img/bread/014big.jpg',
				name: 'Хуторской',
				sort: 'пшенично-ржаной',
				srok: '3 суток',
				descr: 'Пшенично-ржаной хлеб с большим количеством диетических пшеничных отрубей. Живая закваска насыщает этот хлеб со свежим ароматом, легкой кислинкой и естественными витаминами. Без добавления дрожжей. Изготовлен вручную, выпекается на каменном поду.'
			},
			{
				id: '015',
				picSrc: '/img/bread/015.jpg',
				bigPic: '/img/bread/015big.jpg',
				name: 'Багет французский',
				sort: 'пшеничный',
				srok: '3 суток',
				descr: 'Пшеничный хлеб с традиционной хрустящей корочкой, на живой пшеничной закваске.'
			},
			{
				id: '016',
				picSrc: '/img/bread/016.jpg',
				bigPic: '/img/bread/016big.jpg',
				name: 'Чиабатта (пшеничный бездрожжевой хлеб)',
				sort: 'пшеничный',
				srok: '3 суток',
				descr: 'Пшеничный хлеб на живой пшеничной закваске. Имеет крупную неравномерную пористость с чуть прозрачным мякишем. Дарит сливочное послевкусие за счет длительного холодного брожения.'
			},
			{
				id: '017',
				picSrc: '/img/bread/017.jpg',
				bigPic: '/img/bread/017big.jpg',
				name: 'Цельнозерновой ржано-пшеничный БИО',
				sort: 'Ржано-пшеничный',
				srok: '7 суток',
				descr: 'Хлеб на закваске, изготовленный из цельнозерновой БИО муки собственного помола, которая получена из БИО зерна (зерно, выращенное без использования вредных удобрений). Этот хлеб улучшает обмен веществ, способствует снижению избыточного веса, снижает калорийность рациона, выводит избыток холестерина, стимулирует моторные функции кишечника'
			},
			{
				id: '018',
				picSrc: '/img/bread/018.jpg',
				bigPic: '/img/bread/018big.jpg',
				name: 'Ржаной цельнозерновой БИО',
				sort: 'Ржаной',
				srok: '7 суток',
				descr: 'Хлеб на закваске, изготовленный из цельнозерновой БИО муки собственного помола, которая получена из БИО зерна (зерно, выращенное без использования вредных удобрений). Этот хлеб улучшает обмен веществ, способствует снижению избыточного веса, снижает калорийность рациона, выводит избыток холестерина, стимулирует моторные функции кишечника'
			},
			{
				id: '019',
				picSrc: '/img/bread/019.jpg',
				bigPic: '/img/bread/019big.jpg',
				name: 'Сухарики Домашние',
				sort: 'Сухарики',
				srok: '30 суток',
				descr: 'Сухарики содержат много клетчатки и грубого волокна, стимулирующих работу ЖКТ и улучшающих перистальтику кишечника, что позволяет избавиться от синдрома ленивого кишечника.'
			},
			{
				id: '020',
				picSrc: '/img/bread/020.jpg',
				bigPic: '/img/bread/020big.jpg',
				name: 'Сухарики Рижские',
				sort: 'Сухарики',
				srok: '30 суток',
				descr: 'Сухарики содержат много клетчатки и грубого волокна, стимулирующих работу ЖКТ и улучшающих перистальтику кишечника, что позволяет избавиться от синдрома ленивого кишечника. Кроме того содержат цельное зерно тмина, богатое ценными эфирными маслами.'
			},
			{
				id: '021',
				food: 'cookie',
				picSrc: '/img/bread/021.jpg',
				bigPic: '/img/bread/021big.jpg',
				name: 'Печенье Дружба',
				sort: 'Печенье',
				srok: '30 суток',
				descr: 'Сдобное печенье с добавлением овсяных  хлопьев и изюма'
			},
			{
				id: '022',
				food: 'cookie',
				picSrc: '/img/bread/022.jpg',
				bigPic: '/img/bread/022big.jpg',
				name: ' Крошечка (печенье песочное)',
				sort: 'Печенье',
				srok: '90 суток',
				descr: 'Песочное печенье с абрикосовым джемом'
			},
			{
				id: '023',
				food: 'cookie',
				picSrc: '/img/bread/023.jpg',
				bigPic: '/img/bread/023big.jpg',
				name: 'Печенье Винтаж',
				sort: 'Печенье',
				srok: '30 суток',
				descr: 'Сдобное песочное печенье, в состав которого входит солодовый экстракт, что придает ему приятный солодовый вкус и аромат'
			},
			{
				id: '024',
				food: 'cookie',
				picSrc: '/img/bread/024.jpg',
				bigPic: '/img/bread/024big.jpg',
				name: 'Кольцо с кунжутом ',
				sort: 'Печенье',
				srok: '90 суток',
				descr: 'Песочное печенье с добавлением  кунжута'
			},
			{
				id: '026',
				food: 'cookie',
				picSrc: '/img/bread/026.jpg',
				bigPic: '/img/bread/026big.jpg',
				name: 'Рулет с джемом фруктовым',
				sort: 'Печенье',
				srok: '30 суток',
				descr: 'Сдобное печенье с вишневой начинкой'
			},
			{
				id: '027',
				food: 'cookie',
				picSrc: '/img/bread/027.jpg',
				bigPic: '/img/bread/027big.jpg',
				name: 'Меренги (печенье воздушное)',
				sort: 'Печенье',
				srok: '15 суток',
				descr: 'Французский десерт из взбитых с сахаром и высушенных яичных белков'
			},
			{
				id: '028',
				food: 'cookie',
				picSrc: '/img/bread/028.jpg',
				bigPic: '/img/bread/028big.jpg',
				name: 'Курабье (печенье песочное)',
				sort: 'Печенье',
				srok: '90 суток',
				descr: 'Классическое сдобное песочное печенье с абрикосовым повидлом'
			},
			{
				id: '029',
				food: 'cookie',
				picSrc: '/img/bread/029.jpg',
				bigPic: '/img/bread/029big.jpg',
				name: 'Пальчик ',
				sort: 'Печенье',
				srok: '90 суток',
				descr: 'Сдобное печенье с фруктово-ягодной начинкой'
			},
			{
				id: '030',
				food: 'cookie',
				picSrc: '/img/bread/030.jpg',
				bigPic: '/img/bread/030big.jpg',
				name: 'Ленинградское',
				sort: 'Печенье',
				srok: '30 суток',
				descr: 'Классическое сдобное печенье'
			},
			{
				id: '031',
				food: 'cookie',
				picSrc: '/img/bread/031.jpg',
				bigPic: '/img/bread/031big.jpg',
				name: 'Сочники',
				sort: 'Печенье',
				srok: '3 суток',
				descr: 'Мучное кондитерское изделие из песочного теста с творожной начинкой '
			},
			{
				id: '032',
				food: 'cookie',
				picSrc: '/img/bread/032.jpg',
				bigPic: '/img/bread/032big.jpg',
				name: 'Имбирное',
				sort: 'Печенье',
				srok: '60 суток',
				descr: 'Пикантное печенье с тонким ароматом имбиря и небольшим количеством белой глазури'
			},
			{
				id: '033',
				food: 'cookie',
				picSrc: '/img/bread/033.jpg',
				bigPic: '/img/bread/033big.jpg',
				name: 'Клюквянка',
				sort: 'Печенье',
				srok: '90 суток',
				descr: 'Песочное печенье с начинкой крем-брюле, украшенное сладкой клюквой и  белой глазурью'
			},
			{
				id: '034',
				food: 'cookie',
				picSrc: '/img/bread/034.jpg',
				bigPic: '/img/bread/034big.jpg',
				name: 'Кукурузное',
				sort: 'Печенье',
				srok: '60 суток',
				descr: 'Нежное печенье с добавлением кукурузной муки, семян кунжута и льна'
			},
			{
				id: '035',
				food: 'keks',
				picSrc: '/img/bread/035.jpg',
				bigPic: '/img/bread/035big.jpg',
				name: 'Столичный',
				sort: 'Кекс',
				srok: '7 суток',
				descr: 'Классический кекс с изюмом'
			},
			{
				id: '036',
				food: 'cookie',
				picSrc: '/img/bread/036.jpg',
				bigPic: '/img/bread/036big.jpg',
				name: 'Кунжутное (печенье) ',
				sort: 'Печенье',
				srok: '30 суток',
				descr: 'Сдобное песочное печенье с выраженным вкусом кунжута'
			},
			{
				id: '037',
				food: 'cookie',
				picSrc: '/img/bread/037.jpg',
				bigPic: '/img/bread/037big.jpg',
				name: 'Лимонное (печенье) ',
				sort: 'Печенье',
				srok: '30 суток',
				descr: 'Сдобное песочное печенье с ярким вкусом лимона'
			},
			{
				id: '038',
				food: 'cookie',
				picSrc: '/img/bread/038.jpg',
				bigPic: '/img/bread/038big.jpg',
				name: 'Кукурузно-медовое (печенье) ',
				sort: 'Печенье',
				srok: '30 суток',
				descr: 'Сдобное песочное печенье с приятным кукурузно-медовым вкусом'
			}
		]
	},
	mutations: {},
	actions: {},



	getters: {

		getBreads (state) {
			return state.breads
		},

		productsPage (state) {
			return state.breads
		},

		breadById (state) {
			return itemId => {
				return state.breads.find(item => item.id === itemId)
			}
		}
	}
}